import Swiper, { Navigation } from 'swiper';

export default function initAgendaBlock() : void {
    const $agendaContainer = document.querySelectorAll<HTMLElement>('.agenda-wrapper');

    $agendaContainer.forEach($container => {
        new AgendaBlock($container);
    });
}

class AgendaBlock {
    $el: HTMLElement | null | undefined;
    $slider: HTMLElement | null | undefined;
    swiper: Swiper | null = null;


    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$slider = this.$el?.querySelector('.agenda-navigation');
        window.addEventListener('resize', this.onWindowResize.bind(this));
        this.onWindowResize();
    }

    /**
     * Événement lancé à chaque resize de la fenêtre
     * Détermine s'il faut créer ou détruire le swiper
     */
    onWindowResize(): void {

        if (this.$slider) {
            const $buttons = this.$slider.querySelectorAll<HTMLElement>('.agenda-navigation-button');
            let $buttonsLenght = 0;
            const $buttonsContainerWidth =  this.$slider.offsetWidth;
            $buttons.forEach((button) => {
                $buttonsLenght += button.offsetWidth;
            })
            
            
            if (!this.swiper && $buttonsContainerWidth && $buttonsLenght > $buttonsContainerWidth) {
                // Créé le swiper s'il n'est pas déjà créé et que la taille liste des boutons n'est pas supérieure a celle de son container
                this.createSwiper();
            }
            else {
                // Détruit le swiper s'il est déjà créé et que la liste des boutons n'est pas supérieure a celle de son container
                this.destroySwiper();
            }
        }
    }

    /**
     * Créé le swiper
     */
    createSwiper(): void {
        if (this.$slider) {

            this.$slider.classList.add('agenda-navigation--pagination');
            this.$slider.querySelector('.slider-next')?.classList.add('slider-next--active');
            this.$slider.querySelector('.slider-prev')?.classList.add('slider-prev--active');

            new Swiper(this.$slider, {
                modules: [Navigation],
                slidesPerView: 'auto',
                loop: false,
                allowTouchMove: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.slider-next',
                    prevEl: '.slider-prev',
                },
            });
        }
    }

    /**
     * Détruit le swiper
     */
    destroySwiper(): void {

        if (this.$slider) {
            this.$slider.classList.remove('agenda-navigation--pagination');
            this.$slider.querySelector('.slider-next')?.classList.remove('slider-next--active');
            this.$slider.querySelector('.slider-prev')?.classList.remove('slider-prev--active');
        }

        this.swiper?.destroy(true, true);
        this.swiper = null;
    }
}
